/* import __COLOCATED_TEMPLATE__ from './class-group-vpa-points-card.hbs'; */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';

export default class VPAPointsCardComponent extends Component 
{
	@service store;
	@service csv;
	
	@tracked classGroup = null;
	
	@tracked selectedRacePts = null;//pts destination
	@tracked selectedRacePtsName = null;
	
	
	@action
	async selectClassGroup(event)
	{
		var classGroupId = event.target.value;
		
		if(classGroupId == '-')
		{
			this.classGroup = null;
		}
		else
		{
			this.classGroup = await this.store.findRecord('classGroup', classGroupId);
			this.calculateRacePoints();
		}
	}
	
	@action
	selectRacePts(event)
	{
		var ptsCol = event.target.value;
		
		if(ptsCol == '-')
		{
			this.selectedRacePts = null;
			this.selectedRacePtsName = null;
		}
		else
		{
			this.selectedRacePts = ptsCol;
			this.selectedRacePtsName = ptsCol+"Name";
		}
		this.calculateRacePoints();
	}
	
	@action
	async savePoints()
	{
		
		if(this.classGroup && this.selectedRacePts != null)
		{
			var results = await this.classGroup.get('results');
			await this.args.event.hasMany('entries').reload();
			var entries = (await this.args.event.get('entries')).slice();
			for(var result of [...results])
			{
				for(var entry of entries)
				{
					if(entry.bib == result.bib)
					{
						entry.set(this.selectedRacePts,result.calculatedRacePoints);
						await entry.save();
					}
				}
			}
		}
		await this.calculateTeamScores();
		
	}
	
	async calculateRacePoints()
	{
		if(this.classGroup && this.selectedRacePts != null)
		{
			const results = (await this.classGroup.get('results')).slice();
			//sort by team
			results.sort(this.teamSort);
			//check each team for 4 valid starters
			//collect all the teams
			const teamNames = [];
			for(const result of results)
			{
				if(!teamNames.includes(result.club))
				{
					teamNames.push(result.club);
				}
			}
			const teams = [];
			for(const team of teamNames)
			{
				teams.push({name:team,count:0});
			}
			//count valid staters for each team
			for(const result of results)
			{
				if(result.status == "OK"||result.status=="DNF"||result.status=="DSQ")
				{
					for(const team of teams)
					{
						if(team.name == result.club)
						{
							team.count++;
						}
					}
				}
			}
			//mark teams as validforpoints
			for(const result of results)
			{
				result.validForPoints = false;
				for(const team of teams)
				{
					if(team.name == result.club)
					{
						if(team.count >3 && result.status == "OK")
						{
							result.validForPoints = true
						}
					}
				}
			}
			//sort by time
			results.sort(this.placeSort)
			//assign points
			let currentPoints = 1;
			let tiePoints = 1;
			for(const result of results)
			{
				if(result.validForPoints)
				{
					if(result.isTie)
					{
						result.calculatedRacePoints = tiePoints;
						currentPoints++;
					}
					else
					{
						result.calculatedRacePoints = currentPoints;
						currentPoints++;
						tiePoints = currentPoints;
					}
				}
				else
				{
					result.calculatedRacePoints = 0;
				}
			}
		}
	}

	async calculateTeamScores()
	{

		if(this.classGroup && this.selectedRacePts != null)
		{
			let results = (await this.classGroup.get('results')).slice();
			results = results.filter((result) => {
				return result.calculatedRacePoints > 0;
			});
			//sort by school
			results.sort(this.teamSort);
			//collect all the teams
			const teamNames = [];
			for(const result of results)
			{
				if(!teamNames.includes(result.club))
				{
					teamNames.push(result.club);
				}
			}
			results.sort(this.placeSort);
			const teamResults = [];
			teamResults.push([
				"teamName","score1","score2","score3","score4","score5","score6","score7","score8","total"
			]);
			for(const teamName of teamNames)
			{
				let count = 0;
				let sum = 0;
				const scores = [];
				for(const result of results)
				{
					if(result.club == teamName && count < 4)
					{
						sum += result.calculatedRacePoints;
						count++;
						scores.push(result.calculatedRacePoints);
					}
					else if(result.club == teamName)
					{
						scores.push(result.calculatedRacePoints);
					}
				}
				teamResults.push([teamName,scores[0]||"",scores[1]||"",scores[2]||"",scores[3]||"",scores[4]||"",scores[5]||"",scores[6]||"",scores[7]||"",sum]);
			}
			
			this.csv.export(teamResults, {fileName:'teamResults-'+this.classGroup.name+'.csv',withSeparator:false});
		}
		
	}
	
	teamSort(a,b)
	{
		const aClub = a.club || "";
		const bClub = b.club || "";
		return aClub.localeCompare(bClub);
	}
	placeSort(a,b)
	{
		return a.place-b.place;
	}
}